import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-marketplace-not-found',
  imports: [TranslatePipe],
  template: `
    <div class="flex h-screen w-screen flex-col items-center justify-center gap-4 bg-white p-4">
      <h2 class="text-lg font-semibold kiosk:text-8xl">
        {{ 'marketplace.errors.marketplace_not_found' | translate }}
      </h2>
      <p class="text-center kiosk:text-4xl">
        {{ 'marketplace.errors.marketplace_not_found_message' | translate }}
      </p>
    </div>
  `,
})
export class MarketPlaceNotFoundComponent {}
